import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useParams, useSearchParams } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { MyOrderDetail } from 'entities/beket/components/my-order-detail'
import { MyOrderPassenger } from 'entities/beket/components/my-order-passenger'
import { MyOrderRoute } from 'entities/beket/components/my-order-route'
import { PayButton } from 'entities/beket/ui/pay-button'
import { prepareOrderDetail, prepareOrderRoute } from 'entities/beket/utils'

import { BuyTicketApi } from 'shared/api/BuyTicket'
import { MyOrdersBeketApi } from 'shared/api/beket/my-orders/api'
import { OrdersByIdBeket } from 'shared/api/beket/my-orders/model'
import { StatusPurchase } from 'shared/constants'
import ErrorImage from 'shared/images/error.png'
import { getErrorMessage } from 'shared/lib/errorText'
import { startPaymentFromConfirmResult } from 'shared/lib/payment-start'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { Loader } from 'shared/ui/loader'
import { PopupContent } from 'shared/ui/poup-content'

import s from './styles.module.scss'

const BeketMyOrdersPage = observer(() => {
  const { id } = useParams()

  const [searchParams] = useSearchParams()

  const isArchive = !!searchParams.get('isArchive')

  const { openDialog, closeDialog } = useDialogBottomSheet()

  const { t } = useTranslation()

  const [loading, setLoading] = useState<boolean>(false)

  const [orderInfo, setOrderInfo] = useState<OrdersByIdBeket | null>(null)

  const fetchOrderInfo = async () => {
    setLoading(true)

    try {
      const { data: resultResponse } = await MyOrdersBeketApi.getOrderById(
        id || '',
      )

      setOrderInfo(resultResponse?.data)
    } finally {
      setLoading(false)
    }
  }

  const orderDetail = prepareOrderDetail(orderInfo)
  const orderRoute = prepareOrderRoute(orderInfo)

  const onShowError = (errorMessage?: string) => {
    openDialog({
      child: (
        <PopupContent
          image={ErrorImage}
          title={t('error')}
          description={errorMessage || t('please_tey_again')}
          button={t('try_again')}
          onClick={closeDialog}
        />
      ),
      isDialog: false,
    })
  }

  const onRegularPay = async () => {
    try {
      setLoading(true)

      const { data } = await BuyTicketApi.buyTicketConfirm({
        id: String(orderInfo?.order_id),
        type: 'bus_ticket_order',
      })

      await startPaymentFromConfirmResult(data)
    } catch (err) {
      const errorText = getErrorMessage(err)

      onShowError(errorText)
    } finally {
      setLoading(false)
    }
  }

  const isBooked = orderDetail?.status === StatusPurchase.BOOKED.key

  useEffect(() => {
    fetchOrderInfo()
  }, [])
  return (
    <div className={clsx(s.wrapper, 'container')}>
      <HeaderGoBack
        variant="grey"
        title={t('beket.order_detail')}
        buttonWhite
      />

      {loading || !orderInfo ? (
        <Loader />
      ) : (
        <>
          <MyOrderDetail orderInfo={orderDetail} />

          <MyOrderPassenger orderInfo={orderInfo} />

          <MyOrderRoute orderInfo={orderRoute} />

          {!isArchive && isBooked && (
            <div className={s.payment}>
              <PayButton
                count={orderInfo?.tickets?.length}
                price={String(orderInfo?.total_price || '')}
                onSubmit={onRegularPay}
              />
            </div>
          )}

          {/* <MplusPayment
                price={String(orderInfo?.total_price)}
                tranchePrice={String(resultMplusTranche)}
                countPassengers={orderInfo?.tickets?.length}
                onOpenMplus={onOpenMplus}
                onPayRegular={onRegularPay}
                onPayMplus={confirmGetTicketMplus}
              />  */}
        </>
      )}
    </div>
  )
})

export default BeketMyOrdersPage
